import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardBody, Col, Row } from 'reactstrap';
import { ProjectEmployeeList } from '../../../../domain/projectEmployees/projectEmployeeList';

interface Props {
    data: ProjectEmployeeList[];
    onSortingChange?: (columnName: string, sortOrder: 'asc' | 'desc') => void;
    sortedBy?: string | null;
    ascending?: boolean | null;
}

const TeamTab = ({
    data: employees,
    onSortingChange,
    sortedBy,
    ascending,
}: Props) => {
    const getRandomColor = () => {
        const letters = '0123456789ABCDEF';
        let color = '#';
        for (let i = 0; i < 6; i++) {
            color += letters[Math.floor(Math.random() * 16)];
        }
        return color;
    };

    const getInitials = (firstName: string, lastName: string) => {
        const firstInitial = firstName ? firstName[0] : '';
        const lastInitial = lastName ? lastName[0] : '';
        return `${firstInitial}${lastInitial}`.toUpperCase();
    };

    return (
        <React.Fragment>
            <div className='team-list list-view-filter'>
                {employees.map((employee) => (
                    <Card className='team-box' key={employee.id}>
                        <CardBody className='px-4'>
                            <Row className='align-items-center team-row'>
                                <Col lg={4}>
                                    <div className='team-profile-img'>
                                        <div className='avatar-lg img-thumbnail rounded-circle'>
                                            <div
                                                className='avatar-title rounded-circle'
                                                style={{
                                                    backgroundColor:
                                                        getRandomColor(),
                                                    color: 'white',
                                                }}
                                            >
                                                {getInitials(
                                                    employee.firstName,
                                                    employee.lastName
                                                )}
                                            </div>
                                        </div>
                                        <div className='team-content'>
                                            <Link to='#' className='d-block'>
                                                <h5 className='fs-15 mb-1'>
                                                    {employee.firstName}{' '}
                                                    {employee.lastName}
                                                </h5>
                                            </Link>
                                            <p className='text-muted mb-0'>
                                                {employee.positionName}
                                            </p>
                                        </div>
                                    </div>
                                </Col>
                                <Col lg={4}>
                                    <Row className='text-muted text-center'>
                                        <Col
                                            xs={6}
                                            className='border-end border-end-dashed'
                                        >
                                            <h5 className='fs-15 mb-1'>
                                                {employee.projects}
                                            </h5>
                                            <p className='text-muted mb-0'>
                                                Proyectos
                                            </p>
                                        </Col>
                                        <Col xs={6}>
                                            <h5 className='fs-15 mb-1'>
                                                {employee.tasks}
                                            </h5>
                                            <p className='text-muted mb-0'>Tareas</p>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                ))}
            </div>
        </React.Fragment>
    );
};

export default TeamTab;
